import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import { QuestionCircleOutlined, InfoCircleFilled } from '@ant-design/icons';
import React, { useState } from 'react';
import fetchAPI from 'utils/http/fetchAPI';
import { Auth } from '@aws-amplify/auth';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import handleError from 'utils/http/handleError';
var TextArea = _Input.TextArea;
var FeedbackButton = function FeedbackButton(props) {
  var collapsed = props.collapsed,
    buttonType = props.buttonType;
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = useState(''),
    feedbackText = _useState2[0],
    setFeedbackText = _useState2[1];
  var submitFeedback = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var pageContext, user, userContext, feedbackData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setVisible(false);
              pageContext = [{
                type: 'mrkdwn',
                text: '*URL posted from:*'
              }, {
                type: 'mrkdwn',
                text: window.location.href
              }];
              _context.prev = 2;
              _context.next = 5;
              return Auth.currentAuthenticatedUser();
            case 5:
              user = _context.sent;
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              console.warn('User not authenticated');
            case 11:
              userContext = user ? [{
                type: 'mrkdwn',
                text: '*User email:*'
              }, {
                type: 'mrkdwn',
                text: user.attributes.email
              }, {
                type: 'mrkdwn',
                text: '*User name:*'
              }, {
                type: 'plain_text',
                text: user.attributes.name
              }, {
                type: 'mrkdwn',
                text: '*User UUID:*'
              }, {
                type: 'plain_text',
                text: user.username
              }] : [];
              feedbackData = {
                channel: 'feedback',
                blocks: [{
                  type: 'section',
                  text: {
                    type: 'plain_text',
                    text: feedbackText
                  }
                }, {
                  type: 'context',
                  elements: [].concat(pageContext, userContext)
                }]
              };
              _context.prev = 13;
              _context.next = 16;
              return fetchAPI('/v2/sendSlackMessage', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  data: feedbackData
                })
              });
            case 16:
              setFeedbackText('');
              pushNotificationMessage('success', endUserMessages.FEEDBACK_SUCCESSFUL);
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](13);
              handleError(_context.t1, endUserMessages.FEEDBACK_ERROR);
            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8], [13, 20]]);
    }));
    return function submitFeedback() {
      return _ref.apply(this, arguments);
    };
  }();
  var menuItems = [{
    label: __jsx(_Card, {
      size: "small",
      style: {
        padding: '0.5em',
        width: '410px'
      }
    }, "For help using the platform, check out:", __jsx("div", {
      style: {
        margin: '1em'
      }
    }, __jsx("a", {
      href: "https://www.parsebiosciences.com/data-analysis",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Our website"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://support.parsebiosciences.com/hc/en-us/articles/27076682137236-Trailmaker-User-Guide",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "User guide"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://support.parsebiosciences.com/hc/en-us/categories/360004765711-Computational-Support",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Support suite including troubleshooting guides"), ' ', __jsx("br", null), __jsx("a", {
      href: "https://courses.trailmaker.parsebiosciences.com/",
      target: "_blank",
      rel: "noreferrer"
    }, __jsx(InfoCircleFilled, null), ' ', "Free single cell RNA-seq data analysis course")), "To report an issue or to receive 1-to-1 support from a member of our team:", __jsx("br", null), __jsx("br", null), __jsx(_Space, {
      direction: "vertical",
      style: {
        width: '100%'
      }
    }, __jsx(TextArea, {
      value: feedbackText,
      onChange: function onChange(e) {
        setFeedbackText(e.target.value);
      },
      rows: 4,
      placeholder: "Please write your message here to provide feedback or report issues on Trailmaker. A member of our team will get back to you as soon as possible.",
      bordered: true,
      ref: function ref(_ref2) {
        if (_ref2) {
          _ref2.focus();
        }
      },
      style: {
        resize: 'none',
        width: 300,
        outline: 'none'
      }
    }), __jsx(_Space, null, __jsx(_Button, {
      size: "small",
      onClick: function onClick() {
        return setVisible(false);
      }
    }, "Cancel"), __jsx(_Button, {
      size: "small",
      type: "primary",
      onClick: submitFeedback
    }, "Send")))),
    key: 'feedback-button-contents',
    title: ''
  }];
  var buttonStyle = {};
  if (buttonType === 'text') {
    buttonStyle = {
      color: 'hsla(0, 0%, 100%, .65)'
    };
  }
  return __jsx(_Dropdown, {
    open: visible,
    onOpenChange: function onOpenChange(v) {
      return setVisible(v);
    },
    menu: {
      items: menuItems
    },
    placement: "topRight",
    trigger: "click"
  }, __jsx(_Button, {
    type: buttonType,
    icon: __jsx(QuestionCircleOutlined, null),
    style: buttonStyle
  }, !collapsed && 'Support'));
};
FeedbackButton.defaultProps = {
  buttonType: 'default'
};
export default FeedbackButton;